import { AppNS, Dcra } from 'app';

export const saveInspection = (job: Dcra.Inspection): void => {
  localStorage.setItem('newInspection', JSON.stringify(job));
};

export const deleteInspection = (): void => {
  localStorage.removeItem('newInspection');
};

export const getInspectionById = (id: string): Dcra.Inspection | null => {
  const job = localStorage.getItem('newInspection');
  if (job) {
    const jobData = JSON.parse(job) as Dcra.Inspection;
    if (id === jobData.id) {
      return jobData;
    }
  }

  return null;
};

export const getInspectionFromStorage = (): Dcra.Inspection | null => {
  const job = localStorage.getItem('newInspection');
  if (job) {
    return JSON.parse(job) as Dcra.Inspection;
  }

  return null;
};

export const getStoredInspectionParams = (): AppNS.Params => {
  const job = getInspectionFromStorage();
  if (job) {
    return {
      job_id: job.id,
    };
  }
  return {};
};
